import CRUD from '../masterData/genericCRUD'

const route = 'blocks'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function blocks(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		patch: (id, body, config = {}) => {
			return instance.patch(`${route}/${id}`, body, config)
		}
	}
}
